import type { Employee, Image } from "@prisma/client";
import EMPLOYEE_IMAGE_DIMENSIONS from "~/constants/employee/IMAGE_DIMENSIONS";
import useTranslation from "~/kernel/internationalization/useTranslation";
import Heading from "~/ui/Heading";
import List, { ListItem } from "~/ui/List";

type EmployeesProps = {
  employees: Array<
    Pick<Employee, "id" | "name" | "roles"> & {
      image: Pick<Image, "width" | "height"> | null;
      imageUrl: string;
    }
  >;
};

export default function Employees({ employees }: EmployeesProps) {
  const { tt } = useTranslation("employees");

  if (employees.length < 1) {
    return null;
  }

  return (
    <div className="space-y-5">
      <Heading level={2}>{tt("heading")}</Heading>
      <List>
        {employees.map((employee) => (
          <ListItem trim key={employee.id}>
            <div className="flex flex-row space-x-3">
              <div className="w-16 shrink-0 grow-0">
                <img
                  className="w-full rounded-md bg-slate-200"
                  alt={employee.name}
                  src={employee.imageUrl}
                  width={
                    employee.image?.width ?? EMPLOYEE_IMAGE_DIMENSIONS.width
                  }
                  height={
                    employee.image?.height ?? EMPLOYEE_IMAGE_DIMENSIONS.height
                  }
                />
              </div>
              <div className="space-y-1">
                <Heading level={3}>{employee.name}</Heading>
                <p className="text-sm">{employee.roles}</p>
              </div>
            </div>
          </ListItem>
        ))}
      </List>
    </div>
  );
}
